export const pasosDataLayer = {
    "star_tarifier": {},
    "tarifier_step1_personal_data": {
        Asegurado: [
            'Lastname',
            'Firstname',
            'Fecha_de_nacimiento',
        ],
        Provincia: '',
        componentStep: '',
    },
    "tarifier_step2_insured_data": {
        insured_type: '',
        componentStep: ''
    },
    "tarifier_step3_contact_details": {
        Asegurado: [
            'Lastname',
            'Firstname',
            'Fecha_de_nacimiento',
            'telefono'
        ],
        Provincia: '',
        componentStep: '',
    },
    "tarifier_step4_results": {
        Asegurado: [
            'Lastname',
            'Firstname',
            'Fecha_de_nacimiento',
            'telefono'
        ],
        Provincia: '',
        id_presupuesto: '',
        componentStep: '',
    },
    "tarifier_insurance_selection": {
        Asegurado: [
            'Lastname',
            'Firstname',
            'Fecha_de_nacimiento',
            'telefono'
        ],
        Provincia: '',
        id_presupuesto: '',
        Seleccion_usuario: '',
        complemento: '',
        product_name: '',
        ProductType: '',
        componentStep: '',
    },
    "tarifier_insurance_contracting": {
        Asegurado: [
            'Lastname',
            'Firstname',
            'Fecha_de_nacimiento',
            'telefono'
        ],
        Provincia: '',
        id_presupuesto: '',
        Seleccion_usuario: '',
        complemento: '',
        product_name: '',
        componentStep: '',
    },
    "funnel_insurance_contracting": {
        Asegurado: [
            'Lastname',
            'Firstname',
            'Fecha_de_nacimiento',
            'telefono',
            'postalCode',
            'Sexo',
            'Otro_seguro_salud'
        ],
        Provincia: '',
        id_presupuesto: '',
        Seleccion_usuario: '',
        Fecha_inicio_seguro: '',
        complemento: '',
        product_name: '',
        componentStep: '',
    },
    "conversion_insurance_contracting": {
        Asegurado: [
            'Lastname',
            'Firstname',
            'Fecha_de_nacimiento',
            'telefono',
            'postalCode',
            'Sexo'
        ],
        Provincia: '',
        id_presupuesto: '',
        Seleccion_usuario: '',
        complemento: '',
        product_name: '',
        componentStep: '',
        num_asegurados: ''
    },
    "form_error": {
        componentStep: '',
    }
}

export const nuevos_pasos = {
  tarifier_step3_contact_details: "Paso datos de contacto",
  tarifier_step4_results: "Paso resultado de tarificación",
  tarifier_insurance_selection: "tarifier_insurance_selection",
  tarifier_insurance_contracting: "tarifier_insurance_contracting",
  funnel_insurance_contracting: "Comienzo de contratación",
  conversion_insurance_contracting: "Durante la contratación",
};